import {
    UPDATE_BID_SELECTION_TEMPLATE,
} from './bidSelectionTemplate.actions';

/** @type {EmployeeBidSelectionTemplate.IEmployeeBidSelectionTemplate} */
const initialState = {
    anchorDay: 0,
    sourceProfileId: '',
    rebidGroupId: '',
    name: '',
    scheduleSource: -1,
    items: [],
    shifts: {},
    paycodes: {},
    selectionDetails: {
        employeeId: -1,
        bidProcessType: -1,
        preferentialSelection: {}, // do not use this, it is never updated
    },
};

/**
 * @param {EmployeeBidSelectionTemplate.IEmployeeBidSelectionTemplate} state
 * @param {ShiftBidding.IAction} action
 * */
export default function employeeBidSelectionTemplateReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_BID_SELECTION_TEMPLATE:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
}
